<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

// END CONFIGURE axios
export default {
  page: {
    title: "Patient Registration",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      continue_triage:"",
      test: "",
      previous_balance: 0,
      Balance_warning: "",
      current_data: moment(new Date()).format("YYYY-MM-DD"),
      submitted: false,
      submitform: false,
      submit: false,
      typesubmit: false,
      // PATIENT DATA INPUTS
      data: {
        ret_status: 0,
        patient_visitdate: moment(new Date()).format("YYYY-MM-DD"),
        patient_age: "",
        age_unit: "1",
        patient_dob: "",
        patient_next_ofkin: "",
        department: "",
        patient_gender: "",
        patient_muac: "",
        patient_nin: "",
        patient_contact: "",
        patient_country: 235,
        country_code: 256,
        patient_name: "",
        patient_email: "",
        insurance_status: "0",
        pressure: "",
        patient_pulse: "",
        patient_address: "",
        patient_service: "",
        service_cost: "",
        minimum_price: 0,
        service_qty: "1",
        patient_temperature: "",
        patient_weight: "",
        patient_height: "",
        patient_facility: "",
        contact_next_ofkin: "",
        insurance_company: "",
        package: "",
      },
      validation_errors: {
        errortrack: false,
        ret_status: 0,
        patient_visitdate: "",
        patient_next_ofkin: "",
        department: "",
        patient_gender: "",
        patient_muac: "",
        patient_nin: "",
        patient_contact: "",
        patient_country: "",
        country_code: "",
        patient_name: "",
        patient_email: "",
        insurance_status: "",
        pressure: "",
        patient_pulse: "",
        patient_address: "",
        patient_service: "",
        service_cost: "",
        patient_temperature: "",
        patient_weight: "",
        patient_height: "",
        patient_facility: "",
        contact_next_ofkin: "",
        insurance_company: "",
        package: "",
      },
      capture_birth_date:false,
      // PAGE REQUIRED DATA
      allCountryData: [],
      // PAGE HEADERS
      title: "Patient Registration",
      items: [
        {
          text: "Client Section",
          href: "/",
        },
        {
          text: "Register Client",
          active: true,
        },
      ],
      //Speech
      voicevalidation: 0,
      statement: "",
      selectedVoice: 2,
      synth: window.speechSynthesis,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
      // END SPEECH
    };
  },
  methods: {
    ...mapActions({
      FetchCountries: "countries/fetchCountries",
      FetchVillages: "patients/fetchVillages",
      FetchFacilities: "patients/fetchFacilities",
      AddPatient: "patients/addPatient",
      FetchReturningPatients: "patients/fetchReturningPatients",
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchOtherServices: "services/fetchOtherServices",
      FetchInsuranceServices: "insurance/fetchInsuranceServices",
      FetchInsuranceCompanies: "insurance/fetchInsuranceCompanies",
      FetchInsurancePackages: "insurance/fetchInsuranceCompaniesPackages",
      FetchPatientPayments: "payments/fetchPatientPayments",
    }),

    // COMMA SEPERTOR FUNCTION
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR

    initPaymentStatus() {
      (this.data.department = ""),
        (this.data.patient_service = ""),
        (this.data.service_cost = ""),
        (this.data.insurance_company = ""),
        (this.data.package = "");
    },
    // FILTER RETURNING PATIENT
    FilterReturningPatient() {
      if (this.data.patient_name == "" && this.data.ret_status == 1) {
        (this.data.patient_gender = ""),
          (this.data.patient_contact = ""),
          (this.data.patient_email = ""),
          (this.data.patient_address = ""),
          (this.data.patient_nin = ""),
          (this.data.patient_country = 235),
          (this.data.country_code = 256);
      } else {
        var p_name_string = this.data.patient_name;
        var splited_arr = p_name_string.split("-");
        var p_code = splited_arr[0];
        let ret_data = this.ReturningPatients.filter((element) => {
          return element.patientCode == p_code;
        });
        this.test = ret_data;
        if (ret_data) {
          this.data.ret_status = 1;
          let data_object = ret_data[0];
          (this.data.patient_gender = data_object ? data_object.gender : ""),
            (this.data.patient_contact = data_object.patientContact),
            (this.data.patient_email = data_object.patientEmail),
            (this.data.patient_address = data_object.patientAddress),
            (this.data.patient_nin = data_object.NIN);
          this.data.patient_next_ofkin = data_object.lastvisit.next_of_kin;
          this.data.patient_age = data_object.current_age;
          this.data.contact_next_ofkin = data_object.lastvisit.next_of_kin_phone;
          this.previous_balance = data_object.previousbal;
        }
      }
    },
    // END FILTER RETURNING PAYINT

    // SET COUNTRY CODE
    Set_countrycode() {
      let country = this.all_countries.filter((element) => {
        return element.id == this.data.patient_country;
      });

      this.data.country_code = country[0].dialCode;
    },
    // END SET COUNTRY CODE


  
    // SAVE PATIENT
    Save_Patient(type) {
      if(type==1){
        this.continue_triage = 1
      }else{
       this.continue_triage = 2 
      }
      this.validation_errors.errortrack = false;
      //  FINAL VALIDATIONS
      if (this.data.patient_gender == "") {
        this.validation_errors.patient_gender = "Gender is required";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_gender = "";
      }
    

      if (this.data.insurance_status == "") {
        this.validation_errors.insurance_status = "Please select payment type";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.insurance_status = "";
      }

      if (this.data.insurance_status == 1 && this.data.insurance_company == "") {
        this.validation_errors.insurance_company = "Please select Insurance Company";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.insurance_company = "";
      }

      if (this.data.insurance_status == 1 && this.data.package == "") {
        this.validation_errors.package = "Please select a Package";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.package = "";
      }

      if (this.data.patient_service == "") {
        this.validation_errors.patient_service = "Please select a service";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_service = "";
      }

      if (this.data.service_cost == "") {
        this.validation_errors.service_cost = "Please select a service cost";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.service_cost = "";
      }

      // Check price first
      // if (this.data.service_cost < this.data.minimum_price) {
      //   this.validation_errors.service_cost = "Service cost less than "+this.data.minimum_price+" is not accepted";
      //   this.validation_errors.errortrack = true;
      // } else {
      //   this.validation_errors.service_cost = "";
      // }

      if (this.data.department == "") {
        this.validation_errors.department = "Please select a department";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.department = "";
      }

      // END FINAL VALAIDATIONS
      if (this.submitted == false && this.validation_errors.errortrack == false) {
        this.AddPatient(this.data);
        this.submitted = true;
        return;
      }

      if (this.validation_errors.errortrack == true) {
        this.statement = "Your inputs are invalid, please revise and correct them.";
        this.VoceTalkOut();
      }
    },
    // AND SAVE PATIENT
    // SET SERVICE PRICE
    getPrice() {
      if (this.InsuranceServices) {
        let insurace_service = this.InsuranceServices.filter((serve) => {
          return (
            serve.serviceId == this.data.patient_service &&
            serve.package_id == this.data.package
          );
        });
        this.data.service_cost = this.thousandSeprator(insurace_service[0].servicePrice);
      }
    },
    getCost() {
      if (this.data.department == 1) {
        let cos_serveice = this.consultationServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = cos_serveice[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      } else if (this.data.department == 2) {
        let rad_serveice = this.radiologyServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = rad_serveice[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      } else if (this.data.department == 3) {
        let proc_services = this.procedureServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = proc_services[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      } else if (this.data.department == 4) {
        let lab_services = this.labServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = lab_services[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      } else if (this.data.department == 6) {
        let dental_services = this.dentalServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = dental_services[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      } else if (this.data.department == 7) {
        let ante_services = this.antenatalServices.filter((ser) => {
          return ser.id == this.data.patient_service;
        });
        this.data.service_cost = ante_services[0].servicePrice.replace(/,/g, '');
        this.data.minimum_price = this.data.service_cost;
      }else if (this.data.department == 8) {
          let ante_services = this.otherServices.filter((ser) => {
              return ser.id == this.data.patient_service;
          });
          this.data.service_cost = ante_services[0].servicePrice.replace(/,/g, '');
          this.data.minimum_price = this.data.service_cost;
      } else {
        return "0";
      }
    },
    // END SET SERVICE PRICE

    // CLEAR SERVICES INPUTS
    clear_inputs() {
      this.data.service_cost = "";
      this.data.patient_service = "";
    },
    // CLEAR SERVICES INPUT
    /**
     * STAR VOICE VALIDATION
     */
  
    validatecontact() {
      if (this.data.patient_contact[0] == "0") {
        this.validation_errors.errortrack = true;
        this.validation_errors.patient_contact = "Please don't start with a zero";
      } else if (
        isNaN(this.data.patient_contact) ||
        this.data.patient_contact == "-" ||
        this.data.patient_contact == "+"
      ) {
        this.validation_errors.errortrack = true;
        this.validation_errors.patient_contact =
          "Patient contact should only contain numbers";
      } else if (
        this.data.patient_contact.toString().length > 9 &&
        this.data.patient_country == "235"
      ) {
        this.validation_errors.errortrack = true;
        this.validation_errors.patient_contact = "Your input should be 9 characters";
      } else {
        this.validation_errors.patient_contact = "";
      }
    },

    handleValidation() {
      this.validation_errors.errortrack = false;
      if (this.data.patient_name == "") {
        this.validation_errors.patient_name = "Patient name is required";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_name = "";
      }
      if (this.data.patient_visitdate == "") {
        this.validation_errors.patient_visitdate = "Visit date is required";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_visitdate = "";
      }
      if (this.data.patient_country == "") {
        this.validation_errors.patient_country = "Country is required";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_country = "";
      }
      if (this.data.patient_gender == "") {
        this.validation_errors.patient_gender = "Gender is required";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_gender = "";
      }
  
      if (this.data.patient_nin) {
        if (
          (this.data.patient_nin.toString().length > 14 &&
            this.data.patient_country == "235") ||
          (this.data.patient_nin.toString().length < 14 &&
            this.data.patient_country == "235")
        ) {
          this.validation_errors.patient_nin = "NIN Number should be 14 characters";
          this.validation_errors.errortrack = true;
        } else {
          this.validation_errors.patient_nin = "";
        }
      } else {
        this.validation_errors.patient_nin = "";
      }
      if (this.validation_errors.errortrack == true) {
        this.statement = "Your inputs are invalid, please revise and correct them.";
        this.VoceTalkOut();
        return false;
      }
      return true;
    },

    listenForSpeechEvents() {
      this.greetingSpeech.onstart = () => {};
      this.greetingSpeech.onend = () => {};
    },

    VoceTalkOut() {
      if (this.voicevalidation) {
        this.greetingSpeech.text = this.statement;
        this.greetingSpeech.voice = this.voiceList[this.selectedVoice];
        this.synth.speak(this.greetingSpeech);
      }
    },

    // END VOICE VALIDATION
    chagewarnSatatus() {
      let set = { status: this.voicevalidation };
      localStorage.setItem("form_validation", JSON.stringify(set));
    },
    setWarnStatus() {
      if (localStorage.getItem("form_validation")) {
        let k = JSON.parse(localStorage.getItem("form_validation"));
        this.voicevalidation = k.status;
      } else {
        let set = { status: this.voicevalidation };
        localStorage.setItem("form_validation", JSON.stringify(set));
      }
    },
    dateOrAge(state){
      this.data.patient_age="";
      this.data.patient_dob="";
      this.capture_birth_date =  state;
    },
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    // MAP GETTERS
    ...mapGetters("patients", [
      "saving_status",
      "ReturningPatients",
      "Villages",
      "Facilities",
    ]),
    ...mapGetters("countries", ["all_countries"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "antenatalServices",
      "otherServices",
    ]),
    ...mapGetters("insurance", [
      "PaymentType",
      "InsuranceServices",
      "InsuranceCompanies",
      "InsuranceCompaniesPackages",
    ]),
    ...mapGetters("payments", ["PatientPayments"]),

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      if (this.data.department == 1) {
        return this.consultationServices;
      } else if (this.data.department == 2) {
        return this.radiologyServices;
      } else if (this.data.department == 3) {
        return this.procedureServices;
      } else if (this.data.department == 4) {
        return this.labServices;
      } else if (this.data.department == 6) {
        return this.dentalServices;
      } else if (this.data.department == 7) {
        return this.antenatalServices;
      }else if (this.data.department == 8) {
          return this.otherServices;
      } else {
        return [];
      }
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    //FILTER INSURANCE PACKAGES
    filteredComapnyPackages: function () {
      if (this.InsuranceCompaniesPackages) {
        return this.InsuranceCompaniesPackages.filter((pks) => {
          return pks.company_id == this.data.insurance_company;
        });
      } else {
        return [];
      }
    },
    // END FILTER INSURANCE SERVICES

    //FILTER INSURANCE PACKAGES
    filteredPackagesServices: function () {
      if (this.InsuranceServices) {
        return this.InsuranceServices.filter((pks) => {
          return (
            pks.package_id == this.data.package && pks.serviceType == this.data.department
          );
        });
      } else {
        return [];
      }
    },
    // END FILTER INSURANCE SERVICES
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        
        if (this.notificationtype == "success") {
   
          (this.data = {
            ret_status: 0,
            patient_visitdate: moment(new Date()).format("YYYY-MM-DD"),
            patient_next_ofkin: "",
            department: "",
            patient_gender: "",
            patient_muac: "",
            patient_nin: "",
            patient_contact: "",
            patient_country: 235,
            country_code: 256,
            patient_name: "",
            patient_email: "",
            insurance_status: "0",
            pressure: "",
            patient_pulse: "",
            patient_address: "",
            patient_service: "",
            service_cost: "",
            service_qty: "1",
            patient_temperature: "",
            patient_weight: "",
            patient_height: "",
            patient_facility: "",
            contact_next_ofkin: "",
            insurance_company: "",
            package: "",
          }),
            (this.submitted = false);
          this.$toast.success(this.notification_message.msg);
          if(this.continue_triage == 1){
            this.$router.push("/patients/triage");
          }
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  mounted() {
    // wait for voices to load
    // I can't get FF to work without calling this first
    // Chrome works on the onvoiceschanged function
    this.voiceList = this.synth.getVoices();

    if (this.voiceList.length) {
      this.isLoading = false;
    }

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
      // give a bit of delay to show loading screen
      // just for the sake of it, I suppose. Not the best reason
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    };

    this.listenForSpeechEvents();
  },
  created() {
    // Call Actions
    this.setWarnStatus();
    this.FetchCountries();
    this.FetchVillages();
    // this.FetchReturningPatients();
    this.FetchLabServices();
    this.FetchConsultationServices();
    this.FetchRadiologyServices();
    // this.FetchPatientPayments();

    // END Call Actions
    setTimeout(() => {
      this.FetchFacilities();
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
      this.FetchOtherServices();
      this.FetchInsuranceServices();
      this.FetchInsuranceCompanies();
      this.FetchInsurancePackages();
    }, 2000);
  },
};
</script>
<style scoped></style>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            
  <div class="row">
                <div class="col-md-4 form-check form-switch form-switch-md mb-3">
                  <input
                    @change="chagewarnSatatus()"
                    v-model="voicevalidation"
                    v-if="voicevalidation"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                    checked
                  />
                  <input
                    v-else
                    v-model="voicevalidation"
                    @change="chagewarnSatatus()"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                  <label class="form-check-label text-primary" for="SwitchCheckSizemd"
                    >Voice validation</label
                  >
                </div>

                <div class="col-md-4 form-check form-switch form-switch-md mb-3">
                  <input
                    @change="dateOrAge(false)"
                    v-model="capture_birth_date"
                    v-if="capture_birth_date"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                    checked
                  />
                  <input
                    v-else
                    v-model="capture_birth_date"
                    @change="dateOrAge(true)"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                  <label class="form-check-label text-primary" for="SwitchCheckSizemd"
                    >Capture Date of birth instead of Age</label
                  >
                </div>
                <div class="col-md-8" v-if="previous_balance > 0">
                  <h5 style="color: orange">
                    This patient has a pending balance of
                    <b>{{ thousandSeprator(previous_balance) }}</b>
                  </h5>
                </div>
              </div>
             <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label" for="userName">
                        Patient name <span class="text-danger">*</span>
                        <span> For ReturningPatients </span>
                        </label>
                      <input
                        :class="{
                          'is-invalid': validation_errors.patient_name ? true : false,
                        }"
                        v-model="data.patient_name"
                        class="form-control"
                        placeholder="Enter patient name"
                        autocomplete="off"
                      />
                     
                      <div v-if="validation_errors.patient_name" class="invalid-feedback">
                        <span>{{ validation_errors.patient_name }}</span>
                      </div>
                    </div>
                 
                  
                 <div class="form-group">
                      <label class="col-form-label" for="password"
                        >Payment Type <span class="text-danger">*</span></label
                      >
                      <select
                        :class="{
                          'is-invalid': validation_errors.insurance_status ? true : false,
                        }"
                        @change="initPaymentStatus()"
                        class="form-control"
                        v-model="data.insurance_status"
                      >
                        <option
                          v-for="(ty, index) in PaymentType"
                          :key="index"
                          :value="ty.id"
                        >
                          {{ ty.name }}
                        </option>
                      </select>
                      <div
                        v-if="validation_errors.insurance_status"
                        class="invalid-feedback"
                      >
                        <span>{{ validation_errors.insurance_status }}</span>
                      </div>
                    </div>
                    <div class="row" v-show="data.insurance_status == 1">
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="userName"
                          >Insurace Company <span class="text-danger">*</span>
                        </label>
                        <model-list-select
                          :isError="validation_errors.insurance_company ? true : false"
                          :list="InsuranceCompanies ? InsuranceCompanies : []"
                          v-model="data.insurance_company"
                          option-value="id"
                          option-text="companyName"
                          placeholder="select Company"
                        >
                        </model-list-select>
                        <div
                          v-if="validation_errors.insurance_company"
                          class="invalid-feedback"
                        >
                          <span>{{ validation_errors.insurance_company }}</span>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="userName"
                          >Packages <span class="text-danger">*</span>
                        </label>
                        <model-list-select
                          :isError="validation_errors.package ? true : false"
                          @input="clear_inputs()"
                          :list="filteredComapnyPackages ? filteredComapnyPackages : []"
                          v-model="data.package"
                          option-value="id"
                          option-text="packageName"
                          placeholder="select Package"
                        >
                        </model-list-select>
                        <div v-if="validation_errors.package" class="invalid-feedback">
                          <span>{{ validation_errors.package }}</span>
                        </div>
                      </div>
                    </div>

                     <div class="form-group">
                      <label class="col-form-label" for="userName"
                        >Service Category <span class="text-danger">*</span>
                      </label>
                      <model-list-select
                        :isError="validation_errors.department ? true : false"
                        @input="clear_inputs()"
                        :list="departments"
                        v-model="data.department"
                        option-value="id"
                        option-text="name"
                        placeholder="select Category">
                      </model-list-select>
                      <div
                        v-if="validation_errors.department" class="invalid-feedback">
                        <span>{{ validation_errors.department }}</span>
                      </div>
                    </div>

                    <div class="row" v-if="data.insurance_status == 1">
                      <div class="form-group col-md-6">
                        <label class="col-form-label"
                          >Service <span class="text-danger">*</span></label
                        >
                        <span
                          class="text-danger"
                          v-show="
                            filteredPackagesServices.length < 1 &&
                            data.department != '' &&
                            data.package != ''
                          "
                          >No services</span
                        >
                        <model-list-select
                          :isError="
                            validation_errors.patient_service ? true : false
                          "
                          :list="
                            filteredPackagesServices
                              ? filteredPackagesServices
                              : []
                          "
                          v-model="data.patient_service"
                          @input="getPrice()"
                          option-value="serviceId"
                          option-text="serviceName"
                          placeholder="select Service"
                        >
                        </model-list-select>
                        <div v-if="validation_errors.patient_service"
                          class="invalid-feedback">
                          <span>{{ validation_errors.patient_service }}</span>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="servicePrice"
                          >Service Price
                          <span class="text-danger">*</span></label
                        >
                        <input
                          :class="{
                            'is-invalid': validation_errors.service_cost
                              ? true
                              : false,
                          }"
                          autocomplete="off"
                          v-model="data.service_cost"
                          readonly
                          id="servicePrice"
                          type="text"
                          name="service_price"
                          class="form-control"
                          placeholder="Service price"
                        />
                        <div
                          v-if="validation_errors.service_cost"
                          class="invalid-feedback"
                        >
                          <span>{{ validation_errors.service_cost }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="form-group">
                        <label class="col-form-label"
                          >Service<span class="text-danger">*</span></label
                        >
                        <model-list-select
                          :isError="
                            validation_errors.patient_service ? true : false
                          "
                          @input="getCost()"
                          :list="filterSevices ? filterSevices : []"
                          v-model="data.patient_service"
                          option-value="id"
                          option-text="serviceName"
                          placeholder="select Service"
                        >
                        </model-list-select>
                        <div
                          v-if="validation_errors.patient_service"
                          class="invalid-feedback"
                        >
                          <span>{{ validation_errors.patient_service }}</span>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-show="this.data.department == 6 || this.data.department == 8"
                      >
                        <label for="service_qty" class="col-form-label"
                          >Quantity <span class="text-danger">*</span></label
                        >
                        <input
                          autocomplete="off"
                          v-model="data.service_qty"
                          id="service_qty"
                          type="number" min="1"
                          name="service_qty"
                          class="form-control"
                          placeholder="Service Quantity"
                        />
                      </div>
                      <div class="form-group">
                        <label class="col-form-label"
                          >Service Price
                          <span class="text-danger">*</span></label
                        >
                        <input
                          :class="{
                            'is-invalid': validation_errors.service_cost
                              ? true
                              : false,
                          }"
                          autocomplete="off"
                          v-model="data.service_cost"
                          id="service_price"
                          type="number"
                          :min="data.minimum_price"
                          name="service_price"
                          class="form-control"
                          placeholder="Service price"
                        />
                        <div
                          v-if="validation_errors.service_cost"
                          class="invalid-feedback"
                        >
                          <span>{{ validation_errors.service_cost }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label" for="userName"
                        >Visit Date <span class="text-danger">*</span></label
                      >
                      <input
                        :class="{
                          'is-invalid': validation_errors.patient_visitdate
                            ? true
                            : false,
                        }"
                        v-model="data.patient_visitdate"
                        type="date"
                        class="form-control"
                      />
                      <div
                        v-if="validation_errors.patient_visitdate"
                        class="invalid-feedback"
                      >
                        <span>{{ validation_errors.patient_visitdate }}.</span>
                      </div>
                    </div>
   <div class="row">
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="confirmpass"
                          >Country <span class="text-danger">*</span></label
                        >
                        <model-list-select
                          :isError="validation_errors.patient_country ? true : false"
                          @input="Set_countrycode"
                          :list="
                            $store.state.countries.countries.data
                              ? $store.state.countries.countries.data
                              : []
                          "
                          v-model="data.patient_country"
                          option-value="id"
                          option-text="countryName"
                          placeholder="select Country"
                        >
                        </model-list-select>
                        <div
                          v-if="validation_errors.patient_country"
                          class="invalid-feedback"
                        >
                          <span>{{ validation_errors.patient_country }}</span>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="password"
                          >Contact <span class="text-secondary">*</span></label
                        >
                        <div class="input-group">
                          <button
                            class="btn btn-outline-secondary"
                            type="button"
                            id="inputGroupFileAddon03"
                          >
                            +{{ data.country_code }}
                          </button>
                          <input
                            :class="{
                              'is-invalid': validation_errors.patient_contact
                                ? true
                                : false,
                            }"
                            @keyup="validatecontact()"
                            id="contact"
                            type="text"
                            v-model="data.patient_contact"
                            name="contact"
                            autocomplete="off"
                            class="form-control col-md-8"
                            placeholder="Enter contact"
                          />
                          <div
                            v-if="validation_errors.patient_contact"
                            class="invalid-feedback"
                          >
                            <span>{{ validation_errors.patient_contact }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                      <label class="col-form-label" for="residance"
                        >Residence (Local Village)
                        <span class="text-secondary">*</span>
                      </label>
                      <input
                        :class="{
                          'is-invalid': validation_errors.patient_name ? true : false,
                        }"
                        class="form-control"
                        v-model="data.patient_address"
                        list="villagex"
                        placeholder="Enter Residence"
                        autocomplete="off"
                      />
                      <datalist id="villagex">
                        <option
                          v-for="(vill, v) in Villages"
                          :data-value="vill.id"
                          :key="v"
                        >
                          {{ vill.name }}
                        </option>
                      </datalist>
                      <div
                        v-if="validation_errors.patient_address"
                        class="invalid-feedback"
                      >
                        <span>{{ validation_errors.patient_address }}</span>
                      </div>
                    </div>



                         
                       
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="col-form-label" for="gender"
                            >Gender <span class="text-danger">*</span></label
                          >
                          <select
                            :class="{
                              'is-invalid': validation_errors.patient_gender
                                ? true
                                : false,
                            }"
                            class="form-control"
                            v-model="data.patient_gender"
                          >
                            <option value="">Select gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                          </select>
                          <div
                            v-if="validation_errors.patient_gender"
                            class="invalid-feedback"
                          >
                            <span>{{ validation_errors.patient_gender }}.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="capture_birth_date">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="col-form-label" for="age"
                            >Date of birth <span class="text-danger">*</span></label
                          >
                          <input
                            autocomplete="off"
                            id="dob"
                            type="date"
                            v-model="data.patient_dob"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row" v-else>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="col-form-label" for="age"
                            >Age <span class="text-danger">*</span></label
                          >
                          <input
                            autocomplete="off"
                            id="age"
                            type="text"
                            v-model="data.patient_age"
                            class="form-control"
                            placeholder="Enter age"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="col-form-label"
                          >Age Unit<span class="text-danger">*</span></label
                        >
                        <select class="form-control" v-model="data.age_unit">
                          <option value="1">Years</option>
                          <option value="2">Months</option>
                          <option value="4">Weeks</option>
                          <option value="3">Days</option>
                        </select>
                      </div>
                    </div>

                    

                    <div class="form-group">
                      <label class="col-form-label" for="confirmpass">NIN</label>
                      <input
                        :class="{
                          'is-invalid': validation_errors.patient_nin ? true : false,
                        }"
                        autocomplete="off"
                        id="nin"
                        v-model="data.patient_nin"
                        type="text"
                        name="nin"
                        class="form-control"
                        placeholder="Enter NIN (optional)"
                      />
                      <div v-if="validation_errors.patient_nin" class="invalid-feedback">
                        <span>{{ validation_errors.patient_nin }}.</span>
                      </div>
                    </div>
                      
                  </div>
                  <!-- end col -->
                </div>
      
                
                    <button
                        style="float:right;"
                        class="btn btn-primary m-2"
                        type="button"
                        @click="Save_Patient(1)"
                      >
                        Continue To Triage
                        <b-spinner
                          v-if="saving_status && continue_triage == 1"
                          variant="light"
                          small
                          role="status"
                        ></b-spinner>
                         <i v-else class="fa fa-arrow-right"></i>
                      </button>
                         <button
                        style="float:right;"
                        class="btn btn-success m-2"
                        type="button"
                        @click="Save_Patient(2)"
                      >
                        SUBMIT PATIENT
                        <b-spinner
                          v-if="saving_status && continue_triage == 2"
                          variant="light"
                          small
                          role="status"
                        ></b-spinner>
                        <i v-else class="fa fa-check"></i>
                      </button>
        
                <!-- end row -->
              
               
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>